import axios from 'axios'

// Get all courtesies
const getAll = async () => {
  const { data } = await axios.get(`${process.env.VUE_APP_API}/courtesy`)
  return data
}

// Create courtesy
const create = async (id, profit, black, ninja, expiration, active, njBotYan, pfBotYan, baBotYan, dashboard) => {
  const { data } = await axios.post(`${process.env.VUE_APP_API}/courtesy`, {
    id,
    profit,
    black,
    ninja,
    expiration,
    active,
    nj_botyan: njBotYan,
    pf_botyan: pfBotYan,
    ba_botyan: baBotYan,
    dashboard: Boolean(dashboard)
  })
  return data
}

// update courtesy
const update = async (id, profit, black, ninja, expiration, active, njBotYan, pfBotYan, baBotYan, dashboard) => {
  const { data } = await axios.put(`${process.env.VUE_APP_API}/courtesy`, {
    id,
    profit,
    black,
    ninja,
    expiration,
    active,
    nj_botyan: njBotYan,
    pf_botyan: pfBotYan,
    ba_botyan: baBotYan,
    dashboard: Boolean(dashboard)
  })
  return data
}

// Cancel courtesy
const cancel = async (id) => {
  const { data } = await axios.delete(`${process.env.VUE_APP_API}/courtesy/${id}`)
  return data
}

export {
  getAll,
  create,
  update,
  cancel
}
